// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentV2ProcessingResultModel } from './enrollmentV2ProcessingResultModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse {
    'data': EnrollmentV2ProcessingResultModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EnrollmentV2ProcessingResultModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2PatientEnrollmentWithEmailSignatureTemplateRequestResponse.attributeTypeMap;
    }
}
